// Auto-extracted from composerCore.ts. Color palette + tone classnames.
import type { ContentChipColorKey } from "./types";

export const contentChipPalette = [
  { value: "silver", label: "Silver", toneClassName: "library-category-tone-silver" },
  { value: "indigo", label: "Indigo", toneClassName: "library-category-tone-indigo" },
  { value: "sage", label: "Sage", toneClassName: "library-category-tone-sage" },
  { value: "amber", label: "Amber", toneClassName: "library-category-tone-amber" },
  { value: "coral", label: "Coral", toneClassName: "library-category-tone-coral" },
  { value: "sky", label: "Sky", toneClassName: "library-category-tone-sky" },
  { value: "plum", label: "Plum", toneClassName: "library-category-tone-plum" },
] as const;

const paletteSet = new Set<string>(contentChipPalette.map((entry) => entry.value));

export const normalizeColorKey = (value: string | null | undefined): ContentChipColorKey => {
  if (value && paletteSet.has(value)) return value as ContentChipColorKey;
  return "indigo";
};

export const getContentChipToneClassName = (color: string | null | undefined) => {
  const normalized = normalizeColorKey(color);
  return contentChipPalette.find((entry) => entry.value === normalized)?.toneClassName ?? "library-category-tone-indigo";
};
